var map = {
	"./Ears.mp3": 7120,
	"./Eyes.mp3": 5779,
	"./Head.mp3": 8135,
	"./Knees.mp3": 5729,
	"./Mouth.mp3": 3439,
	"./Nose.mp3": 8611,
	"./Shoulder.mp3": 6616,
	"./Toes.mp3": 7989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7719;